import { getApiBaseUrl, type ApiBaseUrlEnv } from '@/shared/api/getApiBaseUrl'

export const ADMIN_TOKEN_STORAGE_KEY = 'maximur_admin_token_v1'

export function getAdminToken(): string | null {
  if (typeof sessionStorage === 'undefined') return null
  return sessionStorage.getItem(ADMIN_TOKEN_STORAGE_KEY)
}

export function setAdminToken(token: string) {
  sessionStorage.setItem(ADMIN_TOKEN_STORAGE_KEY, token.trim())
}

export function clearAdminToken() {
  sessionStorage.removeItem(ADMIN_TOKEN_STORAGE_KEY)
}

function adminHeaders(): HeadersInit {
  const token = getAdminToken()
  const h: HeadersInit = {
    'Content-Type': 'application/json',
  }
  if (token) {
    h.Authorization = `Bearer ${token}`
  }
  return h
}

export async function adminFetch<T>(
  path: string,
  query?: Record<string, string | undefined>,
): Promise<T> {
  const token = getAdminToken()
  if (!token) {
    throw new Error('Нет ключа: войдите на странице /admin/login')
  }
  const base = getApiBaseUrl(import.meta.env as unknown as ApiBaseUrlEnv, window)
  const qs = new URLSearchParams()
  if (query) {
    for (const [k, v] of Object.entries(query)) {
      if (v === undefined || v === '') continue
      qs.set(k, String(v))
    }
  }
  const qstr = qs.toString()
  const url = `${base}${path.startsWith('/') ? path : `/${path}`}${qstr ? `?${qstr}` : ''}`

  const res = await fetch(url, { headers: adminHeaders() })
  if (!res.ok) {
    const text = await res.text()
    let msg = text.slice(0, 400)
    try {
      const j = JSON.parse(text) as { message?: unknown }
      if (typeof j.message === 'string') msg = j.message
      else if (Array.isArray(j.message)) msg = j.message.map(String).join(', ')
    } catch {
      /* keep text */
    }
    const err = new Error(`[${res.status}] ${msg}`)
    ;(err as { status?: number }).status = res.status
    throw err
  }
  return res.json() as Promise<T>
}

export async function adminDelete<T>(path: string): Promise<T> {
  const token = getAdminToken()
  if (!token) {
    throw new Error('Нет ключа: войдите на странице /admin/login')
  }
  const base = getApiBaseUrl(import.meta.env as unknown as ApiBaseUrlEnv, window)
  const pathPart = path.startsWith('/') ? path : `/${path}`
  const url = `${base}${pathPart}`

  const res = await fetch(url, { method: 'DELETE', headers: adminHeaders() })
  if (!res.ok) {
    const text = await res.text()
    let msg = text.slice(0, 400)
    try {
      const j = JSON.parse(text) as { message?: unknown }
      if (typeof j.message === 'string') msg = j.message
      else if (Array.isArray(j.message)) msg = j.message.map(String).join(', ')
    } catch {
      /* keep text */
    }
    const err = new Error(`[${res.status}] ${msg}`)
    ;(err as { status?: number }).status = res.status
    throw err
  }
  if (res.status === 204) {
    return undefined as T
  }
  const ct = res.headers.get('content-type')
  if (ct?.includes('application/json')) {
    return res.json() as Promise<T>
  }
  return undefined as T
}
